export default __webpack_public_path__ + "static/media/VooySubHeader.331008e5.png";